import { render, staticRenderFns } from "./SettingsProducer.vue?vue&type=template&id=3cdd040e&"
import script from "./SettingsProducer.vue?vue&type=script&lang=js&"
export * from "./SettingsProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports